export default __webpack_public_path__ + "static/media/check.f9eaf648.svg";